export default __webpack_public_path__ + "static/media/screen-mobile-active.19a130ad.svg";